<div class="shipment-card">
    <div class="card-attn">{{ card.attn | uppercase }}</div>
    <div class="card-organization">{{ card.organization | uppercase }}</div>
    <div class="card-street1">{{ card.street1 | uppercase }}</div>
    <div class="card-street2">{{ card.street2 | uppercase }}</div>
    <div class="card-street3">{{ card.street3 | uppercase }}</div>
    <div class="card-city-line">
        <span class="card-city">{{ card.city | uppercase }}</span>
        <span class="card-province">{{ card.province | provinceName:card.country | uppercase }}</span>
        <span class="card-postalcode">{{ card.postalCode | uppercase }}</span>
    </div>
    <div class="card-country">
        {{ card.country | countryName | uppercase }}
    </div>
    <div class="card-telephone">{{ card.telephone }}</div>
    <div class="card-email">{{ card.email }}</div>
</div>
